<!-- 异常收货历史 -->
<template>
	<div class='page_content'>
		<div class="page_content_top">
			<v-button :buttonList="buttonList" :buttonFlag="false" @actionSet="actionSet"></v-button>
			<div class="page_content_top_line">
				<el-form :inline="true" size="mini" class="search_form">
                    <el-form-item label="开始日期">
						<el-date-picker size="mini" v-model="getRequestData.start"
							format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
							placeholder="开始日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期">
						<el-date-picker size="mini" @change="changeTime" v-model="getRequestData.end"
							format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
							placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="单位名称">
						<el-input v-model="getRequestData.unitName" placeholder="请输入单位名称" clearable
							maxlength="64"></el-input>
					</el-form-item>
					<el-form-item label="订单号">
						<el-input v-model="getRequestData.orderNo" placeholder="请输入订单号" clearable
							maxlength="64"></el-input>
					</el-form-item>
					<el-form-item label="WMS收货单号">
						<el-input v-model="getRequestData.rcode" placeholder="请输入WMS收货单号" clearable
							maxlength="64"></el-input>
					</el-form-item>
					<el-form-item label="业务类型">
						<el-input v-model="getRequestData.businessType" placeholder="请输入业务类型" clearable
							maxlength="64"></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-select v-model="getRequestData.auditState" placeholder="全部" clearable
							style="width: 160px">
							<el-option v-for="(item, index) in auditStateList" :key="index"
								:label="item.value" :value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
						<el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table size="mini" stripe :data="returnData.list" :height="tableHeight" border style="width: 100%"
				highlight-current-row>
				<el-table-column label="选择操作" width="80" align="center">
					<template slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="businessType" label="业务类型" show-overflow-tooltip
					min-width="100">
				</el-table-column>
				<el-table-column align="center" prop="unitCode" label="单位编号" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column align="center" prop="unitName" label="单位名称" show-overflow-tooltip min-width="160">
				</el-table-column>
				<el-table-column align="center" prop="orderNo" label="订单号" show-overflow-tooltip min-width="140">
				</el-table-column>
				<el-table-column align="center" prop="createrName" label="制单人" show-overflow-tooltip min-width="90">
				</el-table-column>
				<el-table-column align="center" prop="createTime" label="制单时间" show-overflow-tooltip min-width="140">
					<template slot-scope="scope">
						<span v-if="scope.row.createTime">
							{{ $common.getLocalTime(scope.row.createTime) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="rcode" label="WMS收货单号" show-overflow-tooltip min-width="140">
				</el-table-column>
				<el-table-column align="center" prop="auditState" label="状态" show-overflow-tooltip min-width="90">
					<template slot-scope="scope">
						<el-tag size="mini" :type="scope.row.auditState == -1 ? 'danger' :
							scope.row.auditState == 2 ? 'success' : 'info'">
							{{ getAuditStateName(scope.row.auditState) }}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
				@setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
		</div>
		<!-- 异常收货明细查看 -->
		<recependAuditAction ref="recependAuditAction"></recependAuditAction>
		<!-- 审核进度弹窗 -->
		<processAuditAction ref="processAuditAction"></processAuditAction>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			tableHeight: 0,
			// 状态0初始，1已提交，2审核通过，-1审核驳回
			auditStateList: [{
				key: 0,
				value: "初始"
			}, {
				key: 1,
				value: "已提交"
			}, {
				key: 2,
				value: "审核通过"
			}, {
				key: -1,
				value: "审核驳回"
			}],
			getRequestData: {
				unitName: "",
				orderNo: "",
				rcode: "",
				businessType: "",
				auditState: "",
				page: 1,
				rows: 30,
				start: new Date(new Date().toLocaleDateString()).getTime() -
					31 * 24 * 3600 * 1000,
				end: new Date(new Date().toLocaleDateString()).getTime() +
					24 * 60 * 60 * 1000 -
					1,
			},
			returnData: {
				pages: 0, // 总页数
				total: 0, // 总条数
				pageNum: 0, // 当前页数
				list: [],
			},
			buttonList: [],
			selectedDataIndex: 0,
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		// 获取状态名称
		getAuditStateName(val) {
			let item = this.auditStateList.find(i => i.key == val);
			return item ? item.value : "";
		},
		// 结束日期选择
		changeTime(val) {
			if (val) {
				this.getRequestData.end = val + 24 * 60 * 60 * 1000 - 1;
			}
		},
		// 重置搜索条件
		resetSearch() {
			this.getRequestData.unitName = "";
			this.getRequestData.orderNo = "";
			this.getRequestData.rcode = "";
			this.getRequestData.businessType = "";
			this.getRequestData.auditState = "";
			this.getRequestData.start = new Date(new Date().toLocaleDateString()).getTime() -
				31 * 24 * 3600 * 1000;
			this.getRequestData.end = new Date(new Date().toLocaleDateString()).getTime() +
				24 * 60 * 60 * 1000 -
				1;
			this.searchData();
		},
		// 动作集合
		actionSet(actionData) {
            if (this.returnData.list.length <= 0) {
				this.$message({
					message: "暂无数据",
					type: "error",
				});
				return false;
			}
			if (!this.returnData.list[this.selectedDataIndex]) {
				this.$message({
					message: "请先选择您要操作的数据",
					type: "error",
				});
				return false;
			}
			var dataInfo = JSON.parse(
				JSON.stringify(this.returnData.list[this.selectedDataIndex])
			);
            switch (actionData.actionType) {
				case 5: //审核进度
					this.$refs["processAuditAction"].openBox(1, dataInfo.rpid);
					break;
                case 6: // 查看明细
					this.$refs["recependAuditAction"].openBox(dataInfo, true);
					break;
			}
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1;
			this.getDataList();
		},
		// 数据翻页
		setDataPageNumber(val) {
			this.getRequestData.page = val;
			this.getDataList();
		},

		// 切换显示条数
		setDataPageSize(val) {
			this.getRequestData.page = 1;
			this.getRequestData.rows = val;
			this.getDataList();
		},

		// 获取数据列表
		async getDataList() {
			let responseData = await this.$http.recependQueryHis(
				this.getRequestData
			);
			if (responseData.status == 200) {
				this.returnData.list = responseData.result.list || [];
				this.returnData.pages = responseData.result.pages;
				this.returnData.total = responseData.result.total;
				this.returnData.pageNum = responseData.result.pageNum;
				this.selectedDataIndex = 0;
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
			this.setTableHeight();
		},

		// 计算表格高度
		setTableHeight() {
			this.$nextTick(() => {
				this.tableHeight = this.$common.getTableHeight();
			});
		},

		// 获取按钮权限
		async getButtonList() {
			this.buttonList = await this.$common.getActionButton()
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getButtonList();
		this.getDataList();
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		this.setTableHeight();
		window.addEventListener("resize", this.setTableHeight);
	},
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
	beforeDestroy() {
		window.removeEventListener("resize", this.setTableHeight);
	}, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.search_form {
	margin-bottom: 5px;
}
</style>
